export const TYPES = {
  mc: 'mc',
  lo: 'live_ops',
};

// export const OVERVIEW_TIPS = {
//   mc: 'Metrics in the MC Overview (total projects, MAU, and average DAU) are aggregated estimates based on external data sources and may differ from internal reporting. These figures provide a directional view of overall portfolio activity.\nThe MC Total Rev and Top 3 Breakdown is based on DataBrain Dashboard and highlights the top-performing projects from Miniclip.',
//   liveOps:
//     'Live Ops data is based on DataBrain Dashboard and highlights the top-performing projects across all studios, excluding Miniclip.',
// };

export interface IOverviewRankItem {
  shortName: string;
  value: string;
}

export interface IOverviewMetric {
  key: 'gross_revenue' | 'mau' | 'avg_dau';
  title: string;
  value: string;
  dodLabel: string;
  dodValue: string;
  dodDirection: 'up' | 'down';
  rankData: IOverviewRankItem[];
}

export interface IOverviewCardData {
  type: 'mc' | 'live_ops';
  title: string;
  totalLabel: string;
  totalValue: string;
  tips: string;
  metrics: IOverviewMetric[];
}

export interface IEventItem {
  name: string;
  priority: 'High' | 'Medium' | 'Low';
}

export interface IProjectMetricTrend {
  value: string;
  dodLabel: string;
  dodValue: string;
  dodDirection: 'up' | 'down';
  trend: number[];
  yAxis: [number, number, number, number];
  xAxis: [string, string];
}

export interface IProjectRow {
  id: string;
  projectName: string;
  shortName: string;
  icon?: string;
  gameCode: string;
  studioType: 'mc' | 'others';
  grossRevenueRaw: number;
  mgmtOrder: number;
  grossRevenue: IProjectMetricTrend & {
    ytmActual: string;
    ytmKpi: string;
    kpiCompletion: string;
  };
  mau: IProjectMetricTrend;
  avgDau: IProjectMetricTrend;
  events: IEventItem[];
}

export const MULTIPLE_SEPARATED = {
  separated: 'Filter',
};

export const STATUS_OPTIONS = [
  {
    groupKey: 'separated',
    label: 'On Track',
    text: 'On Track',
    value: 'On Track',
  },
  {
    groupKey: 'separated',
    label: 'Delayed',
    text: 'Delayed',
    value: 'Delayed',
  },
];
export const MILESTONE_OPTIONS = [
  {
    groupKey: 'separated',
    label: 'Concept',
    text: 'Concept',
    value: 'Concept',
  },
  {
    groupKey: 'separated',
    label: 'VS (Vertical Slice)',
    text: 'VS (Vertical Slice)',
    value: 'Vertical Slice (VS)',
  },
  {
    groupKey: 'separated',
    label: 'Alpha',
    text: 'Alpha',
    value: 'Alpha',
  },
  {
    groupKey: 'separated',
    label: 'Beta',
    text: 'Beta',
    value: 'Beta',
  },
  {
    groupKey: 'separated',
    label: 'To Be Launched',
    text: 'To Be Launched',
    value: 'To be Launched',
  },
  {
    groupKey: 'separated',
    label: 'Others',
    text: 'Others',
    value: 'Others',
  },
];
